import { sprintf } from 'sprintf-js';
import moment from 'moment';

import _isNull from 'lodash/fp/isNull';

import translation from '../translation';
import Logger from '../../../../../modules/shared/logger';

const log = new Logger({
	name: 'translation-error',
	message: 'Check word in translation file. Word: %s, language: %s, location: %s'
});

const intl = language => {
	const intlFn = (word, ...params) => {
		if (!word) return word;
		if (_isNull(translation[word])) return sprintf(word, ...params);
		let newWord = word;
		if (!translation[word] || !translation[word][language]) {
			log.add(word, language, window.location.href);
		} else {
			newWord = translation[word][language];
		}
		return sprintf(newWord, ...params);
	};
	intlFn.language = language;
	moment.locale(language);

	return intlFn;
};

export default intl;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/shared/intl.js